export default __webpack_public_path__ + "static/media/zawodniczka5.008a2e33.png";